import * as React from 'react';
import clsx from 'clsx';

interface ShareImagePreviewProps {
  /** Object URL of the share card image. */
  imageUrl: string;
  /** Triggers a browser download of the share card PNG. */
  onDownload: () => void;
}

/** Renders the share card image preview with a "SAVE IMAGE" download button. */
export const ShareImagePreview: React.FC<ShareImagePreviewProps> = ({ imageUrl, onDownload }) => (
  <div className='flex flex-col items-center gap-3 px-6 pb-4'>
    <img src={imageUrl} alt='Share preview' className='w-[240px] rounded-12 shadow-lg' />
    <button
      onClick={onDownload}
      className={clsx(
        'flex h-[42px] w-[240px] items-center justify-center rounded-16',
        'border border-purple-120 bg-purple-25',
        'font-sans text-14 font-bold text-brand-800',
        'transition-opacity hover:opacity-80'
      )}
    >
      SAVE IMAGE
    </button>
  </div>
);
